export default {"src":"/_next/static/media/0x20ecc92f0a33e16e8cf0417dfc3f586cf597f3a9.72a6a96a.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};